/* eslint-disable import/prefer-default-export */
import { useDispatch } from 'react-redux';
import { EmployeeReportType } from '../../../../Enums';
import { UPDATE_EMPLOYEE_PREFERENCES_REPORT } from '../../../../store/employeePreferencesReport';

/**
 * @param {{
 *  t: any,
 *  isSequential: boolean
 *  isEnableEmployeeBidResultReport: boolean
 *  isEnableEmployeeRankReport: boolean
 *  setShowReport: Function
 *  employeeId: number
 * }} reports
 * @returns {import("../../../../components/GroupedIconButton/GroupedIconButton").GroupedIconButtonOption[]}
 */
export const getReportOptions = ({
    t,
    isSequential,
    isEnableEmployeeBidResultReport,
    isEnableEmployeeRankReport,
    setShowReport,
    employeeId,
}) => {
    const dispatch = useDispatch();
    const reportOptions = [];
    if (isSequential) {
        reportOptions.push({
            value: EmployeeReportType.EmployeeChoices,
            label: t('common.reports.employeePreferences.title'),
            action: async () => {
                await dispatch({
                    type: UPDATE_EMPLOYEE_PREFERENCES_REPORT,
                    payload: {
                        filters: {
                            selectedEmployees: [employeeId],
                            employeeOptionsInFilter: [employeeId],
                            search: '',
                            dataviewColumnsFilter: [],
                        },
                    },
                });
                setShowReport(EmployeeReportType.EmployeeChoices);
            },
            disabled: false,
        });
    }
    if (isEnableEmployeeRankReport) {
        reportOptions.push({
            value: EmployeeReportType.EmployeeRanks,
            label: t('common.reports.employeeRanks.title'),
            action: () => setShowReport(EmployeeReportType.EmployeeRanks),
            disabled: false,
        });
    }
    if (isEnableEmployeeBidResultReport) {
        reportOptions.push({
            value: EmployeeReportType.EmployeeBiddingResults,
            label: t('common.reports.biddingResults.title'),
            action: () => setShowReport(EmployeeReportType.EmployeeBiddingResults),
            disabled: false,
        });
    }
    return reportOptions;
};
